import {
  FETCH_SMS_STEPS_REQUEST,
  FETCH_SMS_STEPS_SUCCESS,
  FETCH_SMS_STEPS_FAILURE,
  ADD_SMS_STEP_REQUEST,
  ADD_SMS_STEP_SUCCESS,
  ADD_SMS_STEP_FAILURE,
  UPDATE_SMS_STEP_REQUEST,
  UPDATE_SMS_STEP_SUCCESS,
  UPDATE_SMS_STEP_FAILURE,
  DELETE_SMS_STEP_REQUEST,
  DELETE_SMS_STEP_SUCCESS,
  DELETE_SMS_STEP_FAILURE,
  UPDATE_SMS_ORDER_REQUEST,
  UPDATE_SMS_ORDER_SUCCESS,
  UPDATE_SMS_ORDER_FAILURE
} from "./ManageTextSequenceTypes";

const initialState = {
  loading: false,
  steps: [],
  error: null,
  successMessage: null,
};

export const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SMS_STEPS_REQUEST:
    case ADD_SMS_STEP_REQUEST:
    case UPDATE_SMS_STEP_REQUEST:
    case DELETE_SMS_STEP_REQUEST:
    case UPDATE_SMS_ORDER_REQUEST:
      return { ...state, loading: true, successMessage: null, error: null };

    case FETCH_SMS_STEPS_SUCCESS:
      return { ...state, loading: false, steps: action.payload };

    case ADD_SMS_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        steps: [...state.steps, action.payload],
        successMessage: "Message added successfully.",
      };

    case UPDATE_SMS_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        steps: state.steps.map((step) =>
          step.id === action.payload.stepId
            ? { ...step, message: action.payload.message, delayDays: action.payload.delayDays }
            : step
        ),
        successMessage: "Message updated successfully.",
      };

    case DELETE_SMS_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        steps: state.steps.filter((step) => step.id !== action.payload),
        successMessage: "Message deleted successfully.",
      };

    case UPDATE_SMS_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        steps: action.payload,
        successMessage: "Order updated successfully.",
      };

    case FETCH_SMS_STEPS_FAILURE:
    case ADD_SMS_STEP_FAILURE:
    case UPDATE_SMS_STEP_FAILURE:
    case DELETE_SMS_STEP_FAILURE:
    case UPDATE_SMS_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
